'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';

import { openPageModal } from '~/utils/mobileApp';

// URL이 http 또는 https로 시작하는지 확인하는 함수
function isAbsoluteUrl(url: string): boolean {
  return /^(http|https)?:\/\//.test(url);
}

/**
 * 현재 query string 을 유지한 채 페이지 이동하는 훅 (App Router 버전)
 *
 * Pages Router 의 `~/hooks/url` `usePushWithQuery` 를 이관한 것으로,
 * `next/router` 대신 `next/navigation` 의 `useRouter` 를 사용한다.
 */
export const usePushWithQuery = () => {
  const router = useRouter();

  return useCallback(
    (nextUrl: string, isPush = true) => {
      const nextPath = `${nextUrl}${window.location.search}`;

      if (!isAbsoluteUrl(nextUrl) && isPush) {
        router.push(nextPath);
        return;
      }

      void openPageModal(nextPath);
    },
    [router],
  );
};
